ALLOWED_CONTROLLER = 'owners'
ALLOWED_ACTIONS = ['new', 'edit']

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS)

  $(document).on('change', '#default-g7-space-configuration-form input[name="owner[g7_pricing_type_id]"]', (e) ->
    e.preventDefault()
    pricingType = e.target.getAttribute('data-pricing-type')
    $('#default-g7-space-configuration-form .pricing-fields').hide()
    $("#default-g7-space-configuration-form ##{pricingType}-pricing-scheme").show()
  )


$(document).ready(ready)
$(document).on('turbolinks:load', ready)
